import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppConfig } from './app.config';

export const apikeyInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(AppConfig);

  if (!config.apiKey || !req.url.startsWith(config.mobiSubBackUrl)) {
    return next(req);
  }

  return next(
    req.clone({
      headers: req.headers.set('apikey', config.apiKey)
    })
  );
};
